import {combineReducers} from 'redux';

import user from 'ducks/user';
import basket from 'ducks/basket';
import categories from 'ducks/categories';
import {reducer as notifications} from 'react-notification-system-redux';

export default combineReducers({
    user,
    basket,
    categories,
    notifications,
});



// WEBPACK FOOTER //
// ./src/reducers.js